<p-panel [showHeader]="false" class="no-header messages-panel">
    <div class="messages-wrapper" *ngIf="messages.length; else empty" [class.truncated]="isTruncated()">
        <div class="messages">
            @for (msg of limitedMessages(); track msg.publisherId + msg.time + msg.message) {
                <p-message [icon]="msg.icon" [severity]="msg.level" class="error-message">
                    <div class="message-row">
                        <div class="message-summary">
                            <span class="message-publisher">{{ msg.publisherName }}</span>
                            <span class="message-body">
                                {{ msg.message }}
                                @if (pingHost(msg); as host) {
                                    <app-ping-link [host]="host" />
                                }
                            </span>
                        </div>
                        <div class="message-context">
                            <span>{{ formatDetails(msg) }}</span>
                            @if (msg.source) {
                                <span>{{ msg.source }}</span>
                            }
                        </div>
                    </div>
                </p-message>
            }
        </div>
    </div>
    <ng-template #empty>
        <p>No recent errors or warnings.</p>
    </ng-template>
    @if (isTruncated()) {
        <p-button label="See all errors" text routerLink="/tools/diagnostics" class="see-all-link" icon="pi pi-angle-right" iconPos="right" severity="secondary"></p-button>
    }
</p-panel>
